export default {
  widgetContainer: {
    marginRightPx: 20,
  },
};
